export type Country = {
  name: string;
  code: string;
  countryCode: number;
};

export type CountryRegion = {
  name: string;
  code: string;
};

export enum LocationsScope {
  Active = 'active',
  Archived = 'archived',
}

export interface LocationTranslation {
  default: boolean;
  langCode: string;
  name: string;
  note: string;
  postalCode: string;
  city: string;
  street: string;
  fullAddress: string;
  filledCount: number;
  totalCount: number;
}

export interface LocationBrief {
  id: number;
  langCode: string;
  countryCode: string;
  stateCode: string;
  stateName: string;
  name: string;
  note: string;
  postalCode: string;
  city: string;
  street: string;
  fullAddress: string;
  createdAt: string;
  updatedAt: string;
  archivedAt: string;
  isValid: boolean;
}

export interface Location extends LocationBrief {
  activeOffersCount?: number;
  activeRequisitionsCount?: number;
  isDeletable?: boolean;
  translations?: LocationTranslation[];
}

export interface LocationsCounters {
  active: number;
  archived: number;
}

export interface LocationsTranslationCounter {
  default: boolean;
  code: string;
  name: string;
  filledCount: number;
  totalCount: number;
}

export type LocationJobsResponse = {
  offers: Array<{
    id: number;
    title: string;
    slug: string;
    status: string;
    locationIds: number[];
  }>;
};
